(ns assemble.component.table
  (:require ["@mui/material/Grid$default" :as Grid]
            ["@mui/x-data-grid-premium" :refer [GridCell GridMoreVertIcon GridOverlay
                                                GridRow useGridApiContext]]
            ["react" :as react]
            [assemble.component.dropzone :refer [upload-area-placeholder]]
            [assemble.util :as util]
            [uix.core :as uix :refer [$]]))

(def NoRowsContext (react/createContext))
(def NoRowsContextProvider (.-Provider NoRowsContext))

(def NoRowsOverlaySlot
  (uix/as-react
   (fn [{:keys [ref]}]
     (let [{:keys [drop-active asset-type on-open] :as _props} (react/useContext NoRowsContext)]
       ($ GridOverlay
          {:ref ref}
          ($ Grid
             {:container true
              :height "100%"
              :width "100%"
              :bgcolor (when drop-active "grey.60")
              :sx (when drop-active
                    #js {:borderColor "primary.main"
                         :borderWidth 2
                         :borderStyle "dashed"})}
             ($ upload-area-placeholder
                {:drag-active drop-active
                 :asset-type asset-type
                 :on-open on-open})))))))

(def cell-test-id-mapping
  {"revision" #js {:data-testid "revisionColumn"}
   "name" #js {:data-testid "columnName"}
   "type" #js {:data-testid "columnType"}
   "url" #js {:data-testid "columnURL"}
   "status" #js {:data-testid "columnStatus"}
   "creationDate" #js {:data-testid "columnCreationDate"}})

(defn CellSlot [^js props]
  (let [update-props (get cell-test-id-mapping (-> props .-column .-field) #js {})
        new-props (js/Object.assign #js {} update-props props)]
    (react/createElement GridCell new-props)))

(defn RowSlot [name-fn ^js props]
  (let [api (-> (useGridApiContext) .-current)
        row-id (-> props .-rowId)
        row (-> api (.getRow row-id))
        template-name (name-fn row)
        new-props (js/Object.assign #js {:data-testid template-name} props)]
    (react/createElement GridRow new-props)))

(defn MoreActionIconSlot [^js props]
  (react/createElement GridMoreVertIcon (js/Object.assign #js {:data-testid "moreButton"} props)))

(defn get-asset-name-for-test-id
  "Get name from folder name or regular asset.
   For regular asset strip file extension unless it's a font"
  [asset-type ^js props]
  (cond
    (:asset-tree/name props) (:asset-tree/name props)
    (= asset-type :fonts) (:asset/name props)
    :else (util/basename (or (:asset/name props) (:name props)))))
